import { atom } from "recoil";
import { UserData } from "../../../utils/interfaces/user";

export const user = atom<UserData | undefined>({
  key: "user",
  default: undefined,
});
